import { createAction } from "@reduxjs/toolkit";

export const GET_PAGINATED_GUEST_INSIGHTS = "GET_PAGINATED_GUEST_INSIGHTS";
export const GETTING_PAGINATED_GUEST_INSIGHTS_SUCCEEDED = "GETTING_PAGINATED_GUEST_INSIGHTS_SUCCEEDED";
export const GETTING_PAGINATED_GUEST_INSIGHTS_FAILED = "GETTING_PAGINATED_GUEST_INSIGHTS_FAILED";

export const SET_CURRENT_GUEST_DETAIL = "SET_CURRENT_GUEST_DETAIL";
export const UNSET_CURRENT_GUEST_DETAIL = "UNSET_CURRENT_GUEST_DETAIL";

export const GET_CURRENT_GUEST_DETAIL = "GET_CURRENT_GUEST_DETAIL";
export const GETTING_CURRENT_GUEST_DETAIL_SUCCEEDED = "GETTING_CURRENT_GUEST_DETAIL_SUCCEEDED";
export const GETTING_CURRENT_GUEST_DETAIL_FAILED = "GETTING_CURRENT_GUEST_DETAIL_FAILED";

export const UPDATE_TRANSFORMED_GUEST_DETAIL = 'UPDATE_TRANSFORMED_GUEST_DETAIL';

export const UPDATE_GUEST_INSIGHT_FILTERS = 'UPDATE_GUEST_INSIGHT_FILTERS';
export const UPDATE_PAGINATED_GUEST_INSIGHT_FILTERS = 'UPDATE_PAGINATED_GUEST_INSIGHT_FILTERS';
export const RESET_GUEST_INSIGHT_FILTERS = 'RESET_GUEST_INSIGHT_FILTERS';

export const getPaginatedGuestInsights = createAction(GET_PAGINATED_GUEST_INSIGHTS);
export const gettingPaginatedGuestInsightsSucceeded = createAction(GETTING_PAGINATED_GUEST_INSIGHTS_SUCCEEDED);
export const gettingPaginatedGuestInsightsFailed = createAction(GETTING_PAGINATED_GUEST_INSIGHTS_FAILED);

export const setCurrentGuestDetail = createAction(SET_CURRENT_GUEST_DETAIL);
export const unsetCurrentGuestDetail = createAction(UNSET_CURRENT_GUEST_DETAIL);

export const getCurrentGuestDetail = createAction(GET_CURRENT_GUEST_DETAIL);
export const gettingCurrentGuestDetailSucceeded = createAction(GETTING_CURRENT_GUEST_DETAIL_SUCCEEDED);
export const gettingCurrentGuestDetailFailed = createAction(GETTING_CURRENT_GUEST_DETAIL_FAILED);

export const updateTransformedGuestDetail = createAction(UPDATE_TRANSFORMED_GUEST_DETAIL);

export const updateGuestInsightFilters = createAction(UPDATE_GUEST_INSIGHT_FILTERS);
export const updatePaginatedGuestInsightFilters = createAction(UPDATE_PAGINATED_GUEST_INSIGHT_FILTERS);
export const resetGuestInsightFilters = createAction(RESET_GUEST_INSIGHT_FILTERS);